import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import isNumber from 'lodash/isNumber';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';

export default {
  // eslint-disable-next-line complexity
  isNilOrEmpty(value: any): boolean {
    //Checking if value is an empty makes sense only for objects, string or array
    return (
      isNil(value) ||
      ((isObject(value) || isString(value) || isArray(value)) && isEmpty(value))
    );
  },
  // eslint-disable-next-line complexity
  isNilOrEmptyOrNaN(value: any): boolean {
    //Checking if value is an empty makes sense only for objects, string or array
    return this.isNilOrEmpty(value) || (isNumber(value) && isNaN(value));
  },

  removeEmptyStringValuesFromMap(filtersArg: { [key: string]: string }) {
    if (filtersArg) {
      Object.keys(filtersArg).forEach((key) => {
        if (filtersArg[key] === '') {
          delete filtersArg[key];
        }
      });
    }
    return filtersArg;
  },
};
